import Logger from "../../services/logger/Logger";

const SHOW_LOGS = true;
const TAG = "LocalStorageUtils";

export function saveItemOnDevice(itemName: string, base64: string): boolean {
    Logger.info(SHOW_LOGS, TAG, `Saving item on device: ${itemName}`);
    try {
        window.localStorage.setItem(itemName, base64);
        return true;
    } catch (error: any) {
        Logger.error(SHOW_LOGS, TAG, `Failed to save item on device: ${error}`);
        return false;
    }
}

export function deleteItem(itemName: string): boolean {
    Logger.info(SHOW_LOGS, TAG, `Deleting item: ${itemName}`);
    try {
        window.localStorage.removeItem(itemName);
        return true;
    } catch (error: any) {
        Logger.error(SHOW_LOGS, TAG, `Failed to delete item: ${error}`);
        return false;
    }
}

export function loadItem(itemName: string): string | false {
    Logger.info(SHOW_LOGS, TAG, `Loading item: ${itemName}`);
    try {
        const item = window.localStorage.getItem(itemName);
        if (item) {
            return item;
        }
        return false;
    } catch (error: any) {
        Logger.error(SHOW_LOGS, TAG, `Failed to load item: ${error}`);
        return false;
    }
}
